import { useKindeFeatureFlags, useTranslation } from "@next-platform/client-common-core";
import { IconVariants } from "@next-platform/client-common-spicy-ui";
import { CharacterSortOrder } from "@next-platform/packages-ts-types";
import { useMemo, useState } from "react";

import Dropdown from "../../common/Dropdown";

type MyChatbotsSortDropdownProps = {
  value: string;
  onChange: (sortType: string) => void;
};

export default function MyChatbotsSortDropdown({ value, onChange }: MyChatbotsSortDropdownProps) {
  const { hasAccessToV2 } = useKindeFeatureFlags();
  const { t } = useTranslation();
  const [stateCurrentValue, setStateCurrentValue] = useState(value || CharacterSortOrder.Latest);

  const sortItems = useMemo(
    () => [
      { value: CharacterSortOrder.Latest, label: t("search:sortBy.latest") },
      { value: CharacterSortOrder.Oldest, label: t("search:sortBy.oldest") },
      { value: CharacterSortOrder.TopRated, label: t("search:sortBy.topRated") },
      { value: CharacterSortOrder.Name, label: t("search:sortBy.name") },
    ],
    [t],
  );

  const handleSortChange = (sortType: string) => {
    setStateCurrentValue(sortType);
    onChange(sortType);
  };

  const getLabel = (sortValue: string) => {
    const matchedSortItem = sortItems.find((sortItem) => sortItem.value === sortValue);
    return matchedSortItem ? matchedSortItem.label : t("search:sortBy.latest");
  };

  return (
    <Dropdown
      currentValue={getLabel(stateCurrentValue)}
      hasAccessToV2={hasAccessToV2}
      listItems={sortItems.map((sortItem) => ({
        label: sortItem.label,
        value: sortItem.value,
        onPress: () => handleSortChange(sortItem.value),
      }))}
      iconEnd={IconVariants.CHEVRON_DOWN}
    />
  );
}
